import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, CalendarCheck, ClipboardCheck, FolderOpen, MessageSquare, BookOpen } from "lucide-react";

const NAV = [
  { to: "/app/instructor", label: "Panel", icon: LayoutDashboard, end: true },
  { to: "/app/instructor/calendario", label: "Calendario", icon: CalendarCheck },
  { to: "/app/instructor/tareas", label: "Tareas", icon: ClipboardCheck },
  { to: "/app/instructor/biblioteca", label: "Biblioteca", icon: FolderOpen },
  { to: "/app/instructor/mensajes", label: "Mensajes", icon: MessageSquare },
  { to: "/app/instructor/programas", label: "Mis programas", icon: BookOpen },
];

export default function InstructorLayout({ children }) {
  return (
    <DashboardLayout title="Studio del Instructor" navItems={NAV} tenantSlug="dcc">
      {children}
    </DashboardLayout>
  );
}
